require.register("app/billing/receipt/IndexView", function(exports, require, module){
  $0
  
});

